import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  info: {
    display: "flex",
    justifyContent: "space-between",
  },
  infoWrap: {
    display: "flex",
    alignItems: "center",
    width: "96%",
  },
  checkbox: {
    height: "32px",
    width: "32px",
    marginRight: "8px",
    '& .MuiSvgIcon-root': {
      fontSize: 24,
      width: 32,
      height: 32

    },
  },
  title: {
    fontSize: "14px",
    color: "#0E0F0F",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginLeft: "8px",
    marginRight: "8px",
    width: "90%"
  },
  icon: {
    marginRight: "8px"
  }
}));

export default useStyles;
